import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  icon: {
    borderRadius: 4,
    width: 24,
    height: 24,
    backgroundColor: theme.palette.colors.white,
    border: [1, 'solid', '#B3B3B3'],
  },
  checkedIcon: {
    borderColor: theme.palette.colors.teal,
    backgroundColor: theme.palette.colors.teal,
    '&:before': {
      display: 'block',
      width: 13,
      height: 9,
      border: [1, 'solid', theme.palette.colors.white],
      borderTop: 'none',
      borderRight: 'none',
      transform: 'rotate(-45deg)',
      marginTop: 4,
      marginLeft: 5,
      content: '""',
    },
  },
  button: {
    padding: 10,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Checkbox/useStyles.js